/**
 * Authentication Barrel Export - Phase 1
 * 
 * Central export point for authentication utilities.
 * Exposes raw custom attributes from AWS Cognito.
 */

export type { CognitoSessionInfo, CustomAttributes } from './types';
export { getUserInfo, isAuthenticated } from './auth-utils';
export { useAuth } from './useAuth';
